/**
 * TODO:系统扩展类库
 */
// =====================================日期类型===========================================================================
/**
 * 将数字格式化为两位数
 * @param num
 * @returns {string}
 */
const dNumber = (num) => {
  return num < 10 ? ('0' + num) : num
}
/**
 * 日期格式化
 * @param format
 * 格式化参数，支持各种日期格式
 * @returns {string}
 * 返回格式化后日期
 */
/* eslint-disable no-extend-native */
/* eslint-disable indent */
Date.prototype.dateFormart = Date.prototype.dateFormart || function (format) {
  /* eslint-disable no-useless-escape */
  if (isNaN(this.getTime())) {
    return ''
  }
  let formatString = format.match(/[A-Za-z]{1,4}|[\--\/-年-月-日-时-分-秒-\s-:]/g)
  let date = []
  for (let i = 0, len = formatString.length; i < len; i++) {
    switch (formatString[i]) {
      case 'yyyy':
        date.push(this.getFullYear())
        break
      case 'yy':
        date.push(this.getYear())
        break
      case 'MM':
        let month = this.getMonth() + 1
        date.push(dNumber(month))
        break
      case 'M':
        date.push(this.getMonth() + 1)
        break
      case 'dd':
        date.push(dNumber(this.getDate()))
        break
      case 'd':
        date.push(this.getDate())
        break
      case 'HH':
        date.push(dNumber(this.getHours()))
        break
      case 'H':
        date.push(this.getHours())
        break
      case 'mm':
        date.push(dNumber(this.getMinutes()))
        break
      case 'm':
        date.push(this.getMinutes())
        break
      case 'ss':
        date.push(dNumber(this.getSeconds()))
        break
      case 's':
        date.push(this.getSeconds())
        break
      default:
        date.push(formatString[i])
        break
    }
  }
  return date.join('')
}
window.FixedDateIOS = function (date) {
  try {
    date = date.replace(/-/g, '/')
  } catch (e) {
  }
  return new Date(date)
}
Date.prototype.toDateInputValue = function () {
  let local = new Date(this)
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset())
  return local.toJSON().slice(0, 10)
}
/**
 * 洗牌算法，数组随机打乱
 * @type {Function}
 */
Array.prototype.randomArrByArg = Array.prototype.randomArrByArg || function () {
  let index
  let temp
  let len = this.length
  // 打乱数组
  for (let i = 0; i < len; i++) {
    // 产生从 i 到 length 之间的随机数
    index = parseInt(Math.random() * (length - i)) + i
    if (index !== i && index < len && index > -1) {
      temp = this[i]
      this[i] = this[index]
      this[index] = temp
    }
  }
  return this
}
// 获取周几
Date.prototype.getWeek = function () {
  let week = this.getDay()
  switch (week) {
    case 1:
      return '周一'
    case 2:
      return '周二'
    case 3:
      return '周三'
    case 4:
      return '周四'
    case 5:
      return '周五'
    case 6:
      return '周六'
    default:
      return '周日'
  }
}
// 返回星期+日期
Date.prototype.getWeekAndDate = function () {
  let week = this.getWeek()
  let date = this.dateFormart('MM/dd')
  return `${week} ${date}`
}



// WEBPACK FOOTER //
// ./src/lib/utils/system.extended.js